<template>
  <div class="Login">
    <div class="container">
      <div class="row">
          <div class="col-md-3 text-center">
            <img v-if="viewSOK" src="@/assets/images/EstudianteOK.png" alt="Corporación Universitaria Iberoamericana" />
            <img v-if="!viewSOK" src="@/assets/images/EstudianteNULL.png" alt="Corporación Universitaria Iberoamericana" />
          </div>
          <div class="infoRef col-md-9">            
            <div class="dataLogin">                            
              <h4>Bienvenido!</h4>
              <div class="espacio"/> 
              <h3>
                <div v-if="this.$session.get('IberoJWT').name != ''">{{this.$session.get('IberoJWT').name}}</div>
                <div v-else>Estudiante Ibero</div>            
              </h3>
              <div class="espacio"/> 
              <div v-if="viewSOK">
                <div class="espacio"/> 
                <div class="text-center">
                  <router-link to="ibero" >
                    <button type="button" class="btn btn-secondary">Ingreso Campus Virtual</button>
                  </router-link>                    
                </div>
              </div>
              <div v-if="!viewSOK">
                <div>Su usuario no se encuentra activo en el Portal de Estudiantes, por favor actualiza tus datos en Servicio al Estudiante o comunícate a la línea de atención  +57 1 742 6582. <br><br> Si eres docente o administrativo, debes ingresar el en portal de empleados <a :href="this.$store.state.linksRedirect.PTEmple" target="_self">https//intranet.ibero.edu.co</a>.</div>
              </div>              
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import authentication from "@/store/authentication";
import IberoHelpers from "@/store/helpers.js";

export default {
  name: "home",
  components: {},
  data () {
    return {
      viewSOK: true,
    }
  },  
  created: function() {
    if (!this.$session.get("IberoJWTLogin")) {
      authentication.initialize(this.$store.state.configAuth).then(_ => {}).catch(e => console.log(e));
      if (authentication.getUserProfile()) {
        let loader = this.$loading.show();
        this.$session.start();
        this.$session.set("IberoJWT", "");
        this.$session.set("IberoJWT", authentication.getUserProfile());
        var logininf = IberoHelpers.getUserLogin(this.$store,this.$session.get("IberoJWT").upn);
        logininf.then(Response => {
          if (Response === false) {
            this.viewSOK = false
          } else {
            this.$session.set("IberoJWTLogin", "");
            this.$session.set("IberoJWTLogin", Response.data);
            IberoHelpers.sendDataLog(this.$store,authentication.getUserProfile());
            this.$router.push("Ibero");
          }
          loader.hide();
        });
      }
    } else {      
      this.$router.push("Ibero");
    }
  }
};
</script>


<style scoped>
@media screen and (max-width: 767px) {
  .Login {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .dataLogin{
      padding-left: 1%;    
      padding-top: 20px;
  }  
}
@media screen and (max-width: 1000px) and (min-width: 767px) {
  .Login {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .dataLogin{
      padding-left: 30%;    
      padding-top: 20px;
  }  
}
@media screen and (max-width: 1290px) and (min-width: 1000px) {
  .Login {
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 10px;
    padding-bottom: 10px;
  }  
  .dataLogin{
      padding-left: 7%;    
      padding-top: 20px;
  }    
}
@media screen and (min-width: 1290px) {
  .Login {
    padding-left: 20%;
    padding-right: 20%;
    padding-top: 30px;
    padding-bottom: 30px;
  }  
  .dataLogin{
      padding-left: 10%;    
      padding-top: 20px;
  }  
}



.espacio{
  margin-top: 20px;
}

.botonRefence{
  text-align: right; 
}
</style>
